// extracted by mini-css-extract-plugin
export default {"cardImg":"Card_cardImg__OuLWd","cardImgEdit":"Card_cardImgEdit__qvkFi","bg":"Card_bg__YzFzp"};